export const environment = {
  enableProdMode: true,
  creditorAPIEndpoint: '#{creditorAPIEndpoint}#',
  fileUploadScanAPIEndpoint: '#{fileUploadScanAPIEndpoint}#',
  enableVirusScan : '#{enableVirusScan}#',
  instrumentationKey: '#{instrumentationKey}#',
  isCIAMRequired:'#{isCIAMRequired}#',
  goAccessLoginUri: '#{goAccessLoginUri}#',
  clientId: '#{clientId}#',
  clientToken: '#{clientSecret}#',
  redirectUri: '#{redirectUri}#',
  scope: '#{scope}#',
  refreshTimeFactor:'#{scope}#',
  editLockTimer:'#{editLockTimer}#',
  revocationEndpoint:'#{revocationEndpoint}#',
  discoveryCIAMUri:'#{discoveryCIAMUri}#',
  maintenanceTimerSeconds:'#{maintenanceTimerSeconds}#',
  apimSubscriptionKey: '#{apimSubscriptionKey}#'
};